const toPercent = decimal => `${decimal * 100}%`;

export default function objectPositionFromFocalPoint(presentation) {
  if (!presentation) return 'center';

  return `${toPercent(presentation.asJson.focalPoint.x)} ${toPercent(presentation.asJson.focalPoint.y)}`;
}
